import { Modal } from "@mantine/core";
import { useContainerRef } from "../../../../hooks/useContainerRef";
import { ModalFooter } from "../../../../mantine/components/ModalFooter/ModalFooter";
import type { Meter, Site } from "../../../../utils/backend-types";
import type { EnergyDataUploadPartialResult } from "../../EnergyDataUploadFlow/EnergyDataUploadFlow";
import { EnergyDataUploadFlow } from "../../EnergyDataUploadFlow/EnergyDataUploadFlow";

interface EnergyDataUploadModalProps {
  isOpen: boolean;
  variantId: number;
  meters: Array<Meter>;
  sites: Array<Site>;
  defaultMeterId?: number;
  onToggle: () => void;
  onFileUploadStarted: (
    energyDataUploadPartialResults: Array<EnergyDataUploadPartialResult>
  ) => void;
}

function EnergyDataUploadModal({
  isOpen,
  variantId,
  meters,
  sites,
  defaultMeterId,
  onToggle,
  onFileUploadStarted
}: EnergyDataUploadModalProps) {
  const { containerNode, containerRef } = useContainerRef();

  function handleDone(
    energyDataUploadPartialResults?: Array<EnergyDataUploadPartialResult>
  ) {
    if (energyDataUploadPartialResults) {
      onFileUploadStarted(energyDataUploadPartialResults);
    }

    onToggle();
  }

  return (
    <Modal
      className="EnergyDataUploadModal"
      opened={isOpen}
      size="xl"
      title="Upload von Energiedaten"
      onClose={onToggle}
    >
      <EnergyDataUploadFlow
        buttonContainer={containerNode}
        defaultMeterId={defaultMeterId}
        meters={meters}
        sites={sites}
        variantId={variantId}
        onDone={handleDone}
      />
      <ModalFooter ref={containerRef} />
    </Modal>
  );
}

export { EnergyDataUploadModal };
